import script from "./UserPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./UserPasswordView.vue?vue&type=style&index=0&id=609cdd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609cdd7a"]])

export default __exports__